module.exports = __webpack_public_path__ + "img/cloth_g3_item-07.e7cad5c6.svg";